export function isElectron() {
  return typeof window?.ipcRenderer !== 'undefined';
}

export function forceQuit() {
  window?.ipcRenderer?.invoke('runForceQuit');
}
